import { render, staticRenderFns } from "./PaymentView.vue?vue&type=template&id=2abec6e2&scoped=true"
import script from "./PaymentView.vue?vue&type=script&lang=js"
export * from "./PaymentView.vue?vue&type=script&lang=js"
import style0 from "./PaymentView.vue?vue&type=style&index=0&id=2abec6e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abec6e2",
  null
  
)

export default component.exports